import app from '../common_app.es6';

app.filter('brToSeparator', function () {
  return function(text) {
    return text.replace(/<br>/g, '<span class="br-separator"></span>');
  };
});
